import { render, staticRenderFns } from "./Exclamation.vue?vue&type=template&id=03239926"
import script from "./Exclamation.vue?vue&type=script&lang=js"
export * from "./Exclamation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports